import React, { useState } from "react";
import "./Auth.css";
import loginVec from "../../Assets/Images/forgotVec.webp";
import brandLogo from "../../Assets/Images/brandLogo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { postApiCaller } from "../../Libs/apiCaller";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      countryCode: "+1",
      phone: "",
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .required("Phone Number is required")
        .min(10, "Phone number must be 10 digits long")
        .max(15, "Phone number is too long"),
    }),
    onSubmit: async (values) => {
      setIsLoading(true);
      const payload = {
        phone: values.phone,
        countryCode: values.countryCode,
      };
      setTimeout(() => {}, 2000);
      // API call
      const endPoint = "auth/send_otp";
      const response = await postApiCaller(endPoint, payload);
      if (response?.status === 200) {
        toast.success("OTP sent successfully");
        navigate("/otp-verify", {
          state: {
            countryCode: values.countryCode,
            phone: values.phone,
          },
        });
        formik.resetForm();
      } else {
        toast.error(response?.response?.data?.message || response.message);
      }
      setIsLoading(false);
    },
  });

  return (
    <section
      className="bg-login p-6 md:p-4 pb-16 sm:pb-0 min-h-screen flex items-center justify-center
overflow-x-hidden"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 items-stretch w-full max-w-8xl mx-auto gap-0 md:gap-10">
        {/* Right Section (Image & Text) */}
        <div
          className="hidden md:grid relative grid-cols-1 h-full min-h-[calc(100vh-40px)] bg-cover bg-top-center rounded-xl"
          style={{ backgroundImage: `url(${loginVec})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-20 rounded-xl"></div>

          <div className="absolute top-0 text-left text-white p-8 w-3/4">
            <img src={brandLogo} alt="Brand Logo" className="w-20 h-20 mb-4 drop-shadow-lg" />
          </div>
          <div className="">
            <div className="absolute bottom-4 mx-4 w-[calc(100%-2rem)] text-left rounded-lg text-white p-3 backdrop-blur-xs border border-white/30 bg-white/10">
              <p className="capitalize text-md">
                We believe communication should be simple, fast and private.
                Whether you're chatting with friends, connecting with family or
                collaborating with your team, our platform ensures seamless
                messaging and end-to-end security.
              </p>
            </div>
          </div>
        </div>

        {/* Left Section (Form) */}
        <div className="flex items-center justify-center px-4 md:px-0">
          <div className="w-full max-w-lg ">
            <h2 className="text-3xl leading-[50px] font-bold  text-gray-900 w-3/2 mb-4">
              Forgot Password?
            </h2>

            <p className="text-md text-gray-500 mb-6">
              Please enter your registered phone number to receive an activation
              code.
            </p>

            {/* Form */}
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm mb-2">
                  Phone Number
                </label>
                <PhoneInput
                  country={"us"}
                  value={
                    formik.values.countryCode.replace("+", "") +
                    formik.values.phone
                  }
                  onChange={(phone, data) => {
                    const dialCode = data?.dialCode || "";
                    const number = phone.slice(dialCode.length);

                    formik.setFieldValue("countryCode", `+${dialCode}`);
                    formik.setFieldValue("phone", number);
                  }}
                  containerClass="!w-full"
                  inputProps={{
                    placeholder: "Enter phone number",
                    name: "phone",
                    autoFocus: false,
                  }}
                  inputClass="!w-full !py-6 !pl-14 !pr-4 !rounded-lg !border-none !border-gray-300 !focus:ring-2 !focus:ring-purple-500 !focus:border-purple-500 !text-base"
                  buttonClass="!bg-transparent !border-none !outline-none !px-3"
                  dropdownClass="!z-50 border-left"
                  inputStyle={{ width: "100%" }}
                />

                {formik.touched.phone && formik.errors.phone && (
                  <p className="text-red-500 text-sm mt-1 errorMsg">
                    {formik.errors.phone}
                  </p>
                )}
              </div>

              <button
                type="submit"
                className="w-full bg-[var(--primary-color)] text-white py-3 rounded-full text-lg font-medium hover:bg-purple-500 transition"
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Continue"}
              </button>
            </form>

            {/* Sign Up Link */}
            <p className="text-center text-gray-600 text-md mt-8">
              Return to
              <Link
                to="/sign-in"
                className="mx-1 text-purple-600 font-semibold hover:underline w-fit"
              >
                Login
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
